import React from "react";
import { Menu } from "lucide-react";
import { Logo } from "./Logo";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
} from "@/components/ui/sheet";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Standards", href: "#standards" },
  { label: "About", href: "#about" },
];

export const Navbar = () => {
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 inset-x-0 z-50 bg-[#04162E]/95 backdrop-blur-md border-b border-white/15"
    >
      <nav className="mx-auto max-w-[1180px] px-5 lg:px-8 h-[76px] flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" aria-label="Home">
          <Logo />
        </a>

        <div className="hidden md:flex items-center gap-[34px]">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[14.5px] font-medium text-[#D7DEE7] hover:text-white py-1.5 border-b border-transparent hover:border-[#0E8A57] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-consult"
            className="inline-flex items-center justify-center px-[22px] py-3 text-[14.5px] font-semibold text-white bg-[#0E8A57] hover:bg-[#0F9A62] rounded-[2px] transition-colors"
          >
            Request Consultation
          </a>
        </div>

        {/* Mobile */}
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <button
                data-testid="mobile-menu-trigger"
                aria-label="Open menu"
                className="px-3 py-2 text-white border border-white/20 rounded-[2px]"
              >
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent
              side="right"
              className="bg-[#04162E] border-l border-white/15 text-white w-[290px]"
            >
              <div className="mb-8">
                <Logo />
              </div>
              <div className="flex flex-col">
                {LINKS.map((l) => (
                  <SheetClose asChild key={l.href}>
                    <a
                      href={l.href}
                      data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                      className="py-3.5 text-[15px] font-medium text-[#D7DEE7] hover:text-white border-b border-white/10 transition-colors"
                    >
                      {l.label}
                    </a>
                  </SheetClose>
                ))}
                <SheetClose asChild>
                  <a
                    href="#contact"
                    data-testid="mobile-cta-consult"
                    className="mt-6 inline-flex items-center justify-center px-5 py-3 text-[14.5px] font-semibold text-white bg-[#0E8A57] rounded-[2px]"
                  >
                    Request Consultation
                  </a>
                </SheetClose>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </nav>
    </header>
  );
};
